import React, { useEffect, useState } from 'react';
import './admin.css';
import { FiMoreVertical } from 'react-icons/fi';
import API_BASE from "../api/api";

const ViewBook = () => {
  const [books, setBooks] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [editBook, setEditBook] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    price: '',
    description: '',
    highlights: ''
  });
  const [mainImage, setMainImage] = useState(null);
  const [subImages, setSubImages] = useState([]);
  const [previewMainImage, setPreviewMainImage] = useState('');
  const [previewSubImages, setPreviewSubImages] = useState([]);
  const [existingSubImages, setExistingSubImages] = useState([]);

  const toggleMenu = (id) => {
    setOpenMenu(openMenu === id ? null : id);
  };

const fetchBooks = () => {
  fetch(`${API_BASE}/getbook.php`, {
    credentials: "include"
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === "success") {
        setBooks(data.data);
      }
    })
    .catch((err) => console.error(err));
};

useEffect(() => {
  fetchBooks();
}, []);

  const deleteBook = (id) => {
    if (window.confirm("Are you sure you want to delete this book?")) {
fetch(`${API_BASE}/deletebook.php`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ id }),
  credentials: "include" // 🔥 ADD THIS
})
        .then((res) => res.json())
        .then((data) => {
          alert(data.status === "success"
  ? "✅ Book deleted successfully."
  : data.message || "❌ Failed to delete book.");
          fetchBooks();
        })
        .catch((err) => console.error("❌ Error deleting book:", err));
    }
  };

  const handleEdit = (book) => {
    setEditBook(book);
    setFormData({
      title: book.title,
      price: book.price,
      description: book.description,
      highlights: book.highlights
    });

    setPreviewMainImage(`https://sangitshreeprakashan.com/backend/uploads/${book.image?.split('/').pop()}`);
    setMainImage(null);
    setSubImages([]);
    setPreviewSubImages([]);

const subs = Array.isArray(book.sub_images)
  ? book.sub_images.map((img) => ({
      url: `https://sangitshreeprakashan.com/backend/uploads/${img?.split('/').pop()}`,
      path: img
    }))
  : [];
    setExistingSubImages(subs);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    setMainImage(file);
    setPreviewMainImage(URL.createObjectURL(file));
  };

  const handleSubImagesChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setSubImages((prev) => [...prev, ...files]);
      setPreviewSubImages((prev) => [
        ...prev,
        ...files.map((file) => URL.createObjectURL(file))
      ]);
    }
  };

  const removeExistingSubImage = (index) => {
    const updated = [...existingSubImages];
    updated.splice(index, 1);
    setExistingSubImages(updated);
  };

  const removeMainImage = () => {
    setPreviewMainImage('');
    setMainImage(null);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editBook) return;

    const data = new FormData();
    data.append('id', editBook.id);
    data.append('title', formData.title);
    data.append('price', formData.price);
    data.append('description', formData.description);
    data.append('highlights', formData.highlights);
    if (mainImage) data.append('image', mainImage);
    subImages.forEach(file => data.append('sub_images[]', file));
    data.append('existing_sub_images', existingSubImages.map(img => img.path).join(','));

    try {
const res = await fetch(`${API_BASE}/edit.php`, {
  method: 'POST',
  body: data,
  credentials: "include" // 🔥 ADD THIS
});
      const result = await res.json();
      alert(result.message);
      handleCancelEdit();
      fetchBooks();
    } catch (err) {
      console.error("❌ Error updating book:", err);
      alert("Error updating book.");
    }
  };

  const handleCancelEdit = () => {
    setEditBook(null);
    setMainImage(null);
    setSubImages([]);
    setPreviewMainImage('');
    setPreviewSubImages([]);
    setExistingSubImages([]);
  };

  return (
    <div className="viewbook-container">
  <h1 className="dashboard-title">All Books</h1>
      <div className="table-wrapper">
        <table className="book-table">
          <thead>
            <tr>
              <th>ID</th><th>Title</th><th>Price</th><th>Main Image</th>
              <th>Sub Images</th><th>Description</th><th>Highlights</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {books.map((book) => (
              <tr key={book.id}>
                <td>{book.id}</td>
                <td>{book.title}</td>
                <td>₹{book.price}</td>
                <td>
                  <img src={`https://sangitshreeprakashan.com/backend/uploads/${book.image?.split('/').pop()}`} alt="Main" style={{ width: '60px' }} />
                </td>
                <td>
                  {Array.isArray(book.sub_images) &&
  book.sub_images.map((img, i) => (
    <img
      key={i}
      src={`https://sangitshreeprakashan.com/backend/uploads/${img?.split('/').pop()}`}
      style={{ width: '40px', marginRight: '5px' }}
    />
))}
                </td>
                <td>{book.description}</td>
                <td>{book.highlights}</td>
                <td className="action-cell">
                  <FiMoreVertical onClick={() => toggleMenu(book.id)} className="more-icon" />
                  {openMenu === book.id && (
                    <div className="dropdown-menu">
                      <button onClick={() => handleEdit(book)}>Edit</button>
                      <button onClick={() => deleteBook(book.id)}>Delete</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {books.length === 0 && (
              <tr><td colSpan="8" style={{ textAlign: 'center' }}>No books found.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ===== Edit Modal ===== */}
      {editBook && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Book ID: {editBook.id}</h2>
            <form onSubmit={handleEditSubmit} encType="multipart/form-data" className="addbook-form">
              <input type="text" name="title" placeholder="Book Title" value={formData.title} onChange={handleFormChange} required />
              <input type="number" name="price" placeholder="Book Price" value={formData.price} onChange={handleFormChange} required />
              <textarea name="description" placeholder="Description" value={formData.description} onChange={handleFormChange} rows={3} required />
              <textarea name="highlights" placeholder="Highlights (comma-separated)" value={formData.highlights} onChange={handleFormChange} rows={2} />

              <label>Main Image</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                {previewMainImage && (
                  <div style={{ position: 'relative' }}>
                    <img src={previewMainImage} alt="Main Preview" style={{ width: '80px', borderRadius: '6px' }} />
                    <button type="button" onClick={removeMainImage} style={{ position: 'absolute', top: '-6px', right: '-6px', background: 'black', color: 'white', border: '1px solid black', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer' }}>×</button>
                  </div>
                )}
                <input type="file" accept="image/*" onChange={handleMainImageChange} />
              </div>

              <label>Existing Sub Images</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {existingSubImages.map((img, i) => (
                  <div key={i} style={{ position: 'relative' }}>
                    <img src={img.url} alt={`Sub ${i + 1}`} style={{ width: '60px', borderRadius: '6px' }} />
                    <button type="button" onClick={() => removeExistingSubImage(i)} style={{ position: 'absolute', top: '-6px', right: '-6px', background: 'black', border: '1px solid black', color: 'white', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer' }}>×</button>
                  </div>
                ))}
              </div>

              <label>New Sub Images</label>
              <input type="file" multiple accept="image/*" onChange={handleSubImagesChange} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '8px' }}>
                {previewSubImages.map((img, i) => (
                  <img key={i} src={img} alt={`New Sub ${i + 1}`} style={{ width: '60px', borderRadius: '6px' }} />
                ))}
              </div>

              <div style={{ marginTop: '12px', display: 'flex', gap: '12px' }}>
                <button type="submit">Update Book</button>
                <button type="button" className="cancel-button" onClick={handleCancelEdit}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewBook;
